export default __webpack_public_path__ + "static/media/helicopter.01af9820.png";